import axios from "axios";
import https from "https";

class HttpRequest {
  constructor(url = process.env.VUE_APP_API_ENDPOINT) {
    // this.axios = axios
    this.axiosInstance = axios.create({
      baseURL: url,
      timeout: 120000,
      httpsAgent: new https.Agent({
        rejectUnauthorized: false
      })
    });

    this.axiosInstance.defaults.headers.common["Cache-Control"] = "no-cache";
    this.axiosInstance.defaults.headers.common["Content-Type"] =
      "application/json";
    this.axiosInstance.defaults.headers.common["Access-Control-Allow-Origin"] =
      "*";
    this.axiosInstance.defaults.headers.get["Accept"] = "application/json";
    this.axiosInstance.defaults.headers.post["Accept"] = "application/json";

    this.axiosInstance.interceptors.request.use(
      function(config) {
        // Do something before request is sent
        return config;
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    this.axiosInstance.interceptors.response.use(
      function(response) {
        // Do something with response data
        return response;
      },
      function(error) {
        console.log("error", error);
        console.log("error.response", error.response);
        if (!error.response) {
          error["response"] = {
            status: 500,
            message: "500 Internal Server Error"
          }
        } else {
          const storage = JSON.parse(localStorage.getItem("mfu-er-app"));
          if (error.response.status === 401) {
            if (
              error.response.data != undefined &&
              error.response.data.msg == "Wrong username/password"
            ) {
              return error;
            } else {
              storage.application.isExpiredTemp = true;
              storage.application.showPreLoader = false;
              const defaultMsg = "401: Unauthorized";
              storage.application.errorTextTemp =
                error.response && error.response != undefined
                  ? error.response.data.message != undefined &&
                    error.response.data.message.length > 0
                    ? `401: ${error.response.data.message[0]}`
                    : defaultMsg
                  : defaultMsg;

              if (storage.application.errorTextTemp != "") {
                storage.application.showErrorTemp = true;
              }

              localStorage.setItem("mfu-er-app", JSON.stringify(storage));
              return error.response;
            }
          } else if (
            error.response.status === 403 ||
            error.response.status === 405
          ) {
            return error.response;
          }
          //if (error.response.status === 500) {
          if (
            error.response.data !== undefined &&
            error.response.data.code !== undefined &&
            error.response.data.code == 200
          ) {
            return error.response.data;
          }

          if (storage !== null) {
            storage.application.showPreLoader = false;
            storage.application.errorTextTemp =
              error.response && error.response != undefined
                ? error.response.data.msg != undefined
                  ? `${error.response.status}: ${error.response.data.msg}`
                  : error.response.data instanceof Blob
                  ? ""
                  : `${error.response.status}: ${error.response.data}`
                : error.message != undefined
                ? error.message
                : "500 Internal Server Error";
            if (storage.application.errorTextTemp != "") {
              storage.application.showErrorTemp = true;
            }

            localStorage.setItem("mfu-er-app", JSON.stringify(storage));
            // return Promise.reject(error);
          }
        }

        return error.response;
      }
    );
  }

  setHeader(header) {
    // this.axiosInstance.defaults.headers.common[header.key] = header.value
    this.axiosInstance.defaults.headers.common = header;
    // this.axiosInstance.defaults.headers.post["Content-Type"] =
    //   "application/x-www-form-urlencoded";
  }

  setHeaderBearerAuth(token) {
    this.setHeader({ Authorization: `Bearer ${this.variableParser(token)}` });
  }

  variableParser(data, defaultValue = "") {
    return data === undefined ? defaultValue : data;
  }

  get(methodName, data) {
    return this.axiosInstance.get(methodName, {
      params: data
    });
  }

  getBlob(methodName, data) {
    return this.axiosInstance.get(methodName, {
      params: data,
      responseType: "blob"
    });
  }

  create(methodName, data) {
    return this.axiosInstance.post(methodName, data);
  }

  update(methodName, data) {
    return this.axiosInstance.put(methodName, data);
  }

  delete(methodName, param, data) {
    return this.axiosInstance.delete(methodName, {
      params: param,
      data: data
    });
  }

  request(type, url, data) {
    let promise = null;
    switch (type) {
      case "GET":
        promise = axios.get(url, { params: data });
        break;
      case "POST":
        promise = axios.post(url, data);
        break;
      case "PUT":
        promise = axios.put(url, data);
        break;
      case "DELETE":
        promise = axios.delete(url, data);
        break;
      default:
        promise = axios.get(url, { params: data });
        break;
    }
    return promise;
  }
}

export default HttpRequest;
